export default function Contact() {
  return (
    <div className="max-w-5xl mx-auto px-6 py-20">
      <h1 className="text-3xl font-bold text-foreground">Contact Us</h1>
      <p className="mt-4 text-muted-foreground">
        For inquiries or support, email us at:
        <span className="text-primary font-medium">
          {" "}
          info@medigenixhealth.com
        </span>
      </p>
    </div>
  );
}
